function SvgHealtcare(props, { color = "#001CB0", width = 20, height = 20 }) {
  const { color: iconColor, ...restProps } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M2.08203 11.666H7.4987C8.33203 11.666 9.16536 12.916 9.9987 12.916C10.719 12.916 12.0618 12.2935 12.6819 13.4697C12.8779 13.8415 12.6162 14.2663 12.2279 14.4272C11.3287 14.8001 10.3271 15.3065 9.9987 15.416L7.4987 14.5827M12.9154 13.7493L16.7287 12.224C16.9602 12.1314 17.2119 12.1012 17.4588 12.1365C18.3311 12.2611 18.5775 13.4037 17.8341 13.8768L11.4642 17.9304C11.0621 18.1863 10.5698 18.2578 10.1115 18.1268L2.08203 15.8327M9.9987 9.99935C8.39453 9.43462 5.41536 7.00693 5.41536 4.33647C5.41536 2.86163 6.54398 1.66602 7.9362 1.66602C8.78877 1.66602 9.5425 2.11439 9.9987 2.80067C10.4549 2.11439 11.2086 1.66602 12.0612 1.66602C13.4534 1.66602 14.582 2.86163 14.582 4.33647C14.582 7.00693 11.6029 9.43462 9.9987 9.99935Z"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgHealtcare;
